import { render, staticRenderFns } from "./DeleteSystemUser.vue?vue&type=template&id=525d3823"
import script from "./DeleteSystemUser.vue?vue&type=script&lang=js"
export * from "./DeleteSystemUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports